var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1381_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4922 8.99219L12.0078 8.99219L12.0078 3.50781C12.0078 3.22735 11.7805 3 11.5 3C11.2195 3 10.9922 3.22735 10.9922 3.50781L10.9922 8.99219L5.50781 8.99219C5.22735 8.99219 5 9.21954 5 9.5C5 9.78047 5.22735 10.0078 5.50781 10.0078L10.9922 10.0078L10.9922 15.4922C10.9922 15.7727 11.2195 16 11.5 16C11.7805 16 12.0078 15.7727 12.0078 15.4922L12.0078 10.0078L17.4922 10.0078C17.7727 10.0078 18 9.78047 18 9.5C18 9.21954 17.7727 8.99219 17.4922 8.99219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4922 8.79219L12.2078 8.79219L12.2078 3.50781C12.2078 3.11689 11.8909 2.8 11.5 2.8C11.1091 2.8 10.7922 3.11689 10.7922 3.50781L10.7922 8.79219L5.50781 8.79219C5.11689 8.79219 4.8 9.10908 4.8 9.5C4.8 9.89092 5.11689 10.2078 5.50781 10.2078L10.7922 10.2078L10.7922 15.4922C10.7922 15.8831 11.1091 16.2 11.5 16.2C11.8909 16.2 12.2078 15.8831 12.2078 15.4922L12.2078 10.2078L17.4922 10.2078C17.8831 10.2078 18.2 9.89092 18.2 9.5C18.2 9.10908 17.8831 8.79219 17.4922 8.79219Z",
    stroke: "white",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1381_2",
    x: 0.599976,
    y: 0.599609,
    width: 21.8,
    height: 21.8008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.429162 0 0 0 0 0.344375 0 0 0 0 0.95 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1381_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1381_2",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7c92d63538fc6a6a2228fa34f8696bd5.svg";
export { ForwardRef as ReactComponent };